import DragRest from '@spa/scenes/Plannings/DnD/DragRest/DragRest'
import React, { memo } from 'react'
import type { FC } from 'react'

import HandleRestClickContainer from '../HandleRestClickContainer'

import { RestTube } from './RestTube'

type Props = {
  restId: number
  weeklyscheduleId: number
}
export const RestTubeContainer: FC<Props> = memo(
  ({ restId, weeklyscheduleId }) => {
    return (
      <DragRest restId={restId} weeklyscheduleId={weeklyscheduleId}>
        <HandleRestClickContainer
          weeklyscheduleId={weeklyscheduleId}
          restId={restId}
        >
          <RestTube restId={restId} />
        </HandleRestClickContainer>
      </DragRest>
    )
  }
)
